import React, { useState,Component } from 'react';
import axios from 'axios';
import { setUserSession } from '../utils/Common';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import {Footer} from 'react-materialize';
import DataService from "../services/data.service";
import IframeMessage from '../component/IframeMessage';
import { withRouter } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'
import Loading from '../component/loading';




const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

const validateForm = errors => {
  let valid = true;
  Object.values(errors).forEach(val => val.length > 0 && (valid = false));
  return valid;
};

class Payment_Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      showmessage:false,
      // showfailure:true,
      iframeloading:false,
      failuremessage:"Payment Process failed.",
      show_page:false,
      page: "payment",
      loading:true,
      payload:{"lineItems": {}},
      paymenturl:"",
      errors: {
        firstName:'',
        lastName:'',
        customerEmail:'',
        billingAddress1:'',
        billingAddress2:'',
        billingCity:'',
        billingState:'',
        billingPostalCode:'',
        customerPhone:'',
        billingCountry:''

      }
    }
   
    this.handle_message = this.handle_message.bind(this);
    this.failurehandle= this.failurehandle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handle_reload = this.handle_reload.bind(this);
    this.handle_reload_btn = this.handle_reload_btn.bind(this);
    
    this.confirmpayclick=this.confirmpayclick.bind(this);
    this.success_callback = this.success_callback.bind(this);
    this.finishLoading =this.finishLoading.bind(this);
 
    this.handlehelp = this.handlehelp.bind(this);
    this.handle_message = this.handle_message.bind(this);
    this.backclick = this.backclick.bind(this);

    this.calculateTotal = this.calculateTotal.bind(this);
    this.calculateFinalTotal = this.calculateFinalTotal.bind(this);
    this.calculate_payload_data = this.calculate_payload_data.bind(this);

    this.handleWindowBeforeUnload = this.handleWindowBeforeUnload.bind(this);


   

  }
  finishLoading()
  {
   
    this.setState({ iframeloading: !this.state.iframeloading });

  }
  handleSubmit = (event) => {
    event.preventDefault();
    if(validateForm(this.state.errors)) {
      console.info('Form is valid so we pass pot call')
      this.confirmpayclick();
      // let payment_obj={
           
      //   "oneTimeToken": "",
        
      //   "maskedCardNo": "",
        
      //   "aurusTransactionId": "",
        
      //   "cardType": "",
        
      //   "subCardType": "",
        
      //   "networkType": "",
        
      //   "name": ""
        
      //   };
      //   let data={"data":"response="+JSON.stringify(payment_obj,2,null)}
      // this.success_callback(data);
    }else{
      console.error('Form is  Invalid Form')

    }
  }
  calculateTotal(input, checked, tax, line_index, opt_index) {
    let { subtotal } = this.state;
    let { salestax } = this.state;

    if (!checked) {
      subtotal = (parseFloat(subtotal) + parseFloat(input)).toFixed(2);
      salestax = (parseFloat(salestax) + parseFloat(tax)).toFixed(2);
      var total = (parseFloat(subtotal) + parseFloat(salestax)).toFixed(2);
    } else {
      subtotal = (parseFloat(subtotal) - parseFloat(input)).toFixed(2);
      salestax = (parseFloat(salestax) - parseFloat(tax)).toFixed(2);
      var total = (parseFloat(subtotal) + parseFloat(salestax)).toFixed(2);
    }

    this.setState({
      subtotal,
    });
    this.setState({
      salestax,
    });
    this.setState({
      total: total,
    });

    Object.keys(this.state.payload.lineItems).map((item, index) => {
      if (item == line_index) {
        this.state.payload.lineItems[item].optional && this.state.payload.lineItems[item].optional.map(
          (opt_item, opt_index_no) => {
            if (opt_index_no == opt_index) {
              if (!checked) {
                opt_item.checked = true;
              } else {
                opt_item.checked = false;
              }
            }
          }
        );
      }
    });
  }
  backclick() {
    console.log('Click happened');
    
    var payment_page=this.state;
      this.props.history.push({
      pathname: '/',payment_page
     });
  }
  calculate_payload_data() {
    if (this.state.payload != undefined) {
      var subtotal = 0;
      var tax = 0;
      Object.keys(this.state.payload.lineItems).map((item, index) => {
        var amount = parseFloat(this.state.payload.lineItems[item].amount);
        subtotal = (+subtotal + amount).toFixed(2);
        var saletax = parseFloat(this.state.payload.lineItems[item].tax);
        tax = (+tax + saletax).toFixed(2);
      });
      var count = Object.keys(this.state.payload.lineItems).length;
      this.setState({ count: count });
      this.setState({ subtotal: subtotal });

      this.setState({ salestax: tax });
      this.calculateFinalTotal(subtotal, tax);
    }
  }
  calculateFinalTotal(subtotal, tax) {
    var total = (parseFloat(subtotal) + parseFloat(tax)).toFixed(2);
    this.setState({ total: total });
  }
  componentWillUnmount() {
    // you need to unbind the same listener that was binded.
    console.log("removed")
    window.removeEventListener('message', this.success_callback);
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
   }
   
   handleWindowBeforeUnload(event)
   {
    const e = event || window.event;
    // Cancel the event
    e.preventDefault();
    if (e) {
      e.returnValue = ''; 
    }
    return ''; 
   }
   success_callback(event)
   {
     debugger
     console.log("message listener called")
     if(event!=undefined)
     {
     let data=""+event.data;
     
       try
       {
         if(data.split("response=")!=undefined)
         {    
         const res = data.split("response=")
         
         if(res.length == 2) 
         {

           const cardpayload = JSON.parse(res[1]); 

            let payment_obj={
           
             "oneTimeToken": cardpayload.one_time_token,
             
             "maskedCardNo": cardpayload.masked_card_num,
             
             "aurusTransactionId": cardpayload.aurusTransactionId,
             
             "cardType": cardpayload.card_type,
             
             "subCardType": cardpayload.subcard_type,
             
             "networkType": "",
             
             "name": cardpayload.card_holder_name
             
             };
       
             let selected_options=[];
             Object.keys(this.state.payload.lineItems).map((item,index) => {
                 
                  this.state.payload.lineItems[item].optional.map((opt_item,opt_index_no) => {
                     let selected_opt_obj={}
                    
                    if(opt_item.checked)
                    {
                      selected_opt_obj.parentFsaNo=this.state.payload.lineItems[item].fsaNo;
                      selected_opt_obj.parentSku=this.state.payload.lineItems[item].sku;
                      selected_opt_obj.sku=opt_item.sku;
                      selected_options.push(selected_opt_obj);
                    }
                  
                  }) 
         })
         this.setState({selected_options:selected_options})
  
       
          var final_data={
  
            "payment": payment_obj,
  
  
            "billingAddress": {
            
            "firstName": this.state.firstName,
            
            "lastName":  this.state.lastName,
            
            "line1": this.state.billingAddress1,
            
            "line2": this.state.billingAddress2,
            
            "city": this.state.billingCity,
            
            "state": this.state.billingState,
            
            "zip": this.state.billingPostalCode,
            
            "country":this.state.billingCountry,
  
            "moble": this.state.customerPhone
           
            },
            
            "options":selected_options
            }
           console.log("finaldata:"+final_data)
           DataService.post_payment_succees_call(final_data).then(
            response => {
              if(response.status != undefined)
              {
                if(response.status == 200)
                {

                    if(response.data != undefined && response.data.paid != undefined && response.data.paid == true)
                    {
                  
                      let data={
                        confirmationId:response.data.confirmationId,
                        amount:response.data.amount,
                        transactionDate:response.data.transactionDate
                      }
                      console.log("Payment Success")
                      this.props.history.push({
                       pathname: '/success',
                       data
                      });
                    }
                    else
                    {
                      this.setState({
                        showfailure: true,
                        failuremessage: "Payment Process failed."
                      });
                      this.props.history.push({
                        pathname: '/payment_failure',
                      });
                    }
                }
                else
                {
                  this.setState({
                    showfailure: true,
                    failuremessage: "Payment Process failed."
                  });
                  this.props.history.push({
                    pathname: '/payment_failure',
                  });
                }
            
              }
              else
              {
                this.setState({
                  showfailure: true,
                  failuremessage: "Payment Process failed."
                });
                this.props.history.push({
                  pathname: '/payment_failure',
                });
              }
             
              
             
            },
            error => {
              console.log("Payment Failure")
              this.setState({
                showfailure: true,
                failuremessage: "Payment Process failed."
              });
              this.props.history.push({
                pathname: '/payment_failure',
              });
            }
          );
         }
       }
       }
       catch(error)
       {
         console.log(error)
         
       }
     }
   }
  componentDidMount() {
    window.addEventListener('message', this.success_callback);
    window.addEventListener("beforeunload", this.handleWindowBeforeUnload);
    const history = createHistory();
    if (history.location.state && history.location.state.transaction) {
        let state = { ...history.location.state };
        delete state.transaction;
        history.replace({ ...history.location, state });
    }
    if(this.props.location.data!=undefined &&this.props.location.data!=undefined)
    {

     
      let nextProps=this.props.location.data;
      this.setState ({
        count:nextProps.count,
        salestax:nextProps.salestax,
        subtotal:nextProps.subtotal,
        total:nextProps.total,
        payload:nextProps.payload,
        showmessage:nextProps.showmessage,
        loading:nextProps.loading,
        paymenturl:nextProps.paymenturl,
        firstName:nextProps.payload.firstName,
        lastName:nextProps.payload.lastName,
        customerEmail:nextProps.payload.customerEmail,
        billingAddress1:nextProps.payload.billingAddress1,
        billingAddress2:nextProps.payload.billingAddress2,
        billingCity:nextProps.payload.billingCity,
        billingState:nextProps.payload.billingState,
        billingPostalCode:nextProps.payload.billingPostalCode,
        billingCountry:nextProps.payload.billingCountry,
        customerPhone:nextProps.payload.customerPhone,
      });
      this.setState({showmessage:false,loading:true});
      DataService.getPaymenturl().then(
        response => {
          this.setState({
            paymenturl: response.data.iFrameUrl
          });
          console.log(response.data)
          console.log(response.data.iFrameUrl)
          console.log("Okay2")
          this.setState({showmessage:false,loading:false});
          //this.calculate_payload_data();
        },
        error => {
          this.setState({content:(error.response && error.response.data) || error.message ||error.toString()});
          this.setState({showmessage:true,loading:false,iframeloading:false});
  
        }
      );
    }
    else
    {
      window.location.href = '/'
    }
 
    
    

  }
  confirmpayclick()
  {
    try
    {
      let origin=new URL(this.state.paymenturl).origin
      this.refs.iframeid.contentWindow.postMessage('aurus-token', origin)
    }
    catch(error)
    {
      console.log(error)
    }
  }
  handlehelp() {
    // console.log('Click happened');
    // window.location.href = '/payment'
    this.setState({ showhelp: !this.state.showhelp });
  }
  handle_message() {
    // console.log('Click happened');
    // window.location.href = '/payment'
    this.setState({ showmessage: !this.state.showmessage });
  }
  failurehandle()
  {
    debugger
    this.setState({ showfailure: false });
  }
  handle_reload()
  {
    
    this.setState({loading:true,showmessage:false});
    DataService.getPaymenturl().then(
      response => {
        this.setState({
          paymenturl: response.data.iFrameUrl
        });
        console.log(response.data)
        console.log(response.data.iFrameUrl)
        console.log("Okay2")
        this.setState({showmessage:false,loading:false,iframeloading:false});
        //this.calculate_payload_data();
      },
      error => {
        this.setState({content:(error.response && error.response.data) || error.message ||error.toString()});
        this.setState({showmessage:true,loading:false,iframeloading:false});

      }
    );
  }
  handle_reload_btn()
  {
    this.setState({
      iframeloading: true
    });
    this.setState({showmessage:false});
    DataService.getPaymenturl().then(
      response => {
        this.setState({
          paymenturl: response.data.iFrameUrl
        });
        console.log(response.data)
        console.log(response.data.iFrameUrl)
        console.log("Okay2")
        this.setState({showmessage:false,iframeloading:false});
        //this.calculate_payload_data();
      },
      error => {
        this.setState({content:(error.response && error.response.data) || error.message ||error.toString()});
        this.setState({showmessage:true,iframeloading:false});

      }
    );
  }

  componentWillReceiveProps(nextProps) {
      debugger
   // window.addEventListener('message', this.success_callback());
    // this.setState({ data: nextProps.data }); 
     this.setState ({
       count:nextProps.count,
       salestax:nextProps.salestax,
       subtotal:nextProps.subtotal,
       total:nextProps.total,
       payload:nextProps.payload,
       showmessage:nextProps.showmessage,
       loading:nextProps.loading,
       paymenturl:nextProps.paymenturl,
       firstName:nextProps.payload.firstName,
       lastName:nextProps.payload.lastName,
       customerEmail:nextProps.payload.customerEmail,
       billingAddress1:nextProps.payload.billingAddress1,
       billingAddress2:nextProps.payload.billingAddress2,
       billingCity:nextProps.payload.billingCity,
       billingState:nextProps.payload.billingState,
       billingPostalCode:nextProps.payload.billingPostalCode,
       customerPhone:nextProps.payload.customerPhone,
     });
      
   
     
   }
   handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case 'firstName': 
        errors.firstName = 
          value.length < 3
            ? 'First Name must be at least 3 characters long!'
            : '';
        break;
        case 'lastName': 
        errors.lastName = 
          value.length < 3
            ? 'Last Name must be at least 3 characters long!'
            : '';
        break;
        
        
      case 'customerEmail': 
        errors.customerEmail = 
          validEmailRegex.test(value)
            ? ''
            : 'Email is not valid!';
        break;

        case 'billingAddress1': 
        errors.billingAddress1 = 
          value.length < 3
            ? 'Address1 Name must be at least 3 characters long!'
            : '';
        break;

        case 'billingAddress2': 
        errors.billingAddress2 = 
          value.length < 3
            ? 'Address1 Name must be at least 3 characters long!'
            : '';
        break;

        case 'billingCity': 
        errors.billingCity = 
          value.length == 0
            ? 'City should not be empty!'
            : '';
        break;

        case 'billingState': 
        errors.billingState = 
          value.length == 0
            ? 'State should not be empty!'
            : '';
        break;

        case 'billingPostalCode': 
        errors.billingPostalCode = 
          value.length == 0
            ? 'PostalCode should not be empty!'
            : '';
        break;
        
      case 'customerPhone': 
        errors.customerPhone = 
          value.length < 10
            ? 'Please Enter Valid Phone Number!'
            : '';
        break;
      case 'billingCountry': 
        errors.billingCountry = 
          value.length == 0
            ? 'Please Enter Valid Country Name!'
            : '';
        break;
      default:
        break;
    }

    this.setState({errors, [name]: value});
  }
    render() {
      const {errors} = this.state;
        return (
          
          <div className="">
          <div  className=' mt-2 col-md-12 col-sm-12'>
        
          <h3 className='size_28'>FUR Service Renewal Notice</h3>
          <div className="row">
            <h3 className="text-left size_24 mt-3 review_font">Payment </h3>
            <hr className="line1 mt-1 mb-1"></hr>
          </div>
              <div className="row d-flex justify-content-center" >
               <div class="col-md-6" style={this.state.showfailure ? { display: 'block' } : { display: 'none' }}>
                <div class="alert alert-danger " role="alert">
                  <a class="close hand" onClick={this.failurehandle}>&times;</a>
                  {this.state.failuremessage}
                </div> 
                </div>
              </div>
          <div className='row'>
       
  
          <div className='col-md-4  col-12  mt-3  order-md-1 order-2'>
              <div className='total_bg bg_mobile p-4'>
              <br></br>
              <div className="row ">
              <div className="row ">
                   <div className="col-md-8 col-sm-8 col-8 text-left">
                   <label className="text-left payment_info sub_total_font"> Payment SubTotal ({this.state.count} items)</label>
                   </div>
                   <div className='col-md-4 col-sm-4 col-4 text-right'>
                   <label className="text-right payment_info sub_total_font">${this.state.subtotal} </label>
                   </div>
                     
                </div>
                <div className="row ">
                   <div className="col-md-8  col-sm-8 col-8 text-left">
                   <label className="text-left payment_info sub_total_font">Sales Tax</label>
                   </div>
                   <div className='col-md-4  col-sm-4 col-4 text-right'>
                   <label className="text-right payment_info sub_total_font">${this.state.salestax}</label>
                   </div>
                     
                </div>
                <div className="row ">
                   <div className="col-md-8  col-sm-8 col-8 text-left">
                   <label className="text-left total_font">Payment Total</label>
                   </div>
                   <div className='col-md-4 col-sm-4 col-4 text-right'>
                   <label className="text-right total_font">${this.state.total}</label>
                   </div>
                     
                </div>
                
                <div className="row ">
                   <div className="col-md-12 ">
                   <hr className="line1 mt-2 mb-2"></hr>
                   <h5 className="text-left  total_font">Item Summary</h5>
                   </div>
                     
                </div>
                </div>
                <div className="row payment_scroll">
                {
               Object.keys(this.state.payload.lineItems).map((item,index) => {
              return (
                <div className=" col-md-12 text-left mt-2">
                   <div className="row mt-1" >
                      <div className="col-md-12 text-left mb-1">
                        <label class=" product_info_title">
                          {this.state.payload.lineItems[item].itemDescription}{" "}
                        </label>
                      </div>
                    </div>
                  <div className="row text-left mt-2 product_info">
                    <div className="col-md-4 col-sm-4 col-3 pr-0">
                      <label class=" grey_text">SKU#:</label>
                    </div>
                    <div className="col-md-8 col-sm-8 col-9 p-0">
                      <label class=" cus_info_bold">{this.state.payload.lineItems[item].sku}</label>
                    </div>
                    {/* <div className="col-md-4 col-sm-4 col-3 pr-0">
                      <label class=" grey_text grey_text">Policy#:</label>
                    </div>
                    <div className="col-md-8 col-sm-8 col-9 p-0">
                      <label class=" cus_info_bold">{this.state.payload.lineItems[item].sku}
                      </label>
                    </div> */}
                    <div className="col-md-4 col-sm-4 col-3 pr-0">
                      <label class=" grey_text grey_text">FSA#:</label>
                    </div>
                    <div className="col-md-8 col-sm-8 col-9 p-0">
                      <label class=" cus_info_bold">{this.state.payload.lineItems[item].fsaNo}</label>

                    </div>
  
                    </div>
                    <div className="row mt-1" >
                          <div className="col-md-12 ">
                            <label class="payment_info_sub sub_total_font">Service:</label>
                          </div>
                      </div>
                    <div className="row" >
                          <div className="col-md-4 col-sm-4 col-3 pr-0">
                            <label class="payment_info_sub">{this.state.payload.lineItems[item].description}</label>
                          </div>
                          <div className="col-md-8 col-sm-8 col-9 p-0">
                            <label class="payment_info_sub"> ${this.state.payload.lineItems[item].amount}</label>
                          </div>
                        
                    </div>
                    <div className="row" style={this.state.payload.lineItems[item].optional.length > 0 && this.state.payload.lineItems[item].optional.filter(x=>x.checked).length > 0 ? {} : {display: 'none'}} >
                          <div className="col-md-12 col-sm-12 col-3 pr-0">
                            <label class="payment_info_sub sub_total_font">Optional:</label>
                          </div>
                         
                        
                    </div>
                   
                       {
                        this.state.payload.lineItems[item].optional &&this.state.payload.lineItems[item].optional.map((opt_item,index_opt) =>{
  
                      return (
                        <div className="row" style={opt_item.checked ? {} : {display: 'none'}}>
                          <div className="col-md-4 col-sm-4 col-3 pr-0">
                            <label class="payment_info_sub">{opt_item.description}</label>
                          </div>
                          <div className="col-md-8 col-sm-8 col-9 p-0">
                            <label class="payment_info_sub"> ${opt_item.amount}</label>
                          </div>
                        
                        </div>
                        )
                      }
                     )
                    }
  
                
                     
                </div>
                 )
             
                })
              }
           
               
  
           </div>          
              </div>
          </div>


          <div className='col-md-8  col-12 mt-3  order-md-2 order-1'>
  
                          <div className='total_bg p-4'>
                              <br></br>
                              <div className='d-none d-md-block'>
                             <div className="row  ">
                                  <div className="col-md-6 col-sm-6 col-12 text-left">
                                  <lable className="text-left payment_head">Billing Address</lable>
                                  </div>
                                 
                              </div>
                            
                              <div className="row  mt-2 ">
                                  <div className="col-md-6 col-sm-6 col-12 text-left">
                                  <input type="text" class="form-control" className={`form-control ${errors.firstName.length > 0 ? 'is-invalid' : '' }`} value={this.state.firstName} name="firstName" placeholder="First Name" onChange={this.handleChange} noValidate></input>
                                  {errors.firstName.length > 0 && 
                                  <span className='invalid-feedback'>{errors.firstName}</span>}
                                  </div>
                                  <div className='col-md-6 col-sm-6 col-12 text-left'>
                                  <input type="text" class="form-control" className={`form-control ${errors.lastName.length > 0 ? 'is-invalid' : '' }`} value={this.state.lastName} name="lastName" placeholder="Last Name" onChange={this.handleChange} ></input>
                                  {errors.lastName.length > 0 && 
                                  <span className='invalid-feedback'>{errors.lastName}</span>}
                                  </div>
  
                              </div>
  
                              <div className="row  mt-2">
                                  <div className="col-md-6 col-sm-6 col-6 text-left">
                                  <input type="text" class="form-control" className={`form-control ${errors.customerEmail.length > 0 ? 'is-invalid' : '' }`}  placeholder="Email" name="customerEmail" value={this.state.customerEmail} onChange={this.handleChange}></input>
                                  {errors.customerEmail.length > 0 && 
                                  <span className='invalid-feedback'>{errors.customerEmail}</span>}
                                  </div>
                                  <div className="col-md-6 col-sm-6 col-6 text-left">
                                  <input type="text" class="form-control"  className={`form-control ${errors.customerPhone.length > 0 ? 'is-invalid' : '' }`} placeholder="Phone" name="customerPhone" value={this.state.customerPhone} onChange={this.handleChange}></input >
                                  {errors.customerPhone.length > 0 && 
                                  <span className='invalid-feedback'>{errors.customerPhone}</span>}
                                  </div>
                              </div>
                              <div className="row  mt-2">
                                  <div className="col-md-6 col-sm-6 col-6 text-left">
                                  <input type="text" class="form-control" className={`form-control ${errors.billingAddress1.length > 0 ? 'is-invalid' : '' }`} placeholder="Address1" name="billingAddress1" value={this.state.billingAddress1} onChange={this.handleChange}></input>
                                  {errors.billingAddress1.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingAddress1}</span>}
                                  </div>
                                  <div className="col-md-6 col-sm-6 col-6 text-left">
                                  <input type="text" class="form-control"   placeholder="Address2" name="billingAddress2" value={this.state.billingAddress2} onChange={this.handleChange}></input>
                                 
                                  </div>
                              </div>
                              
  
                              <div className="row  mt-2">
                                  <div className="col-md-6 col-sm-6 col-12 text-left">
                                  <input type="text" class="form-control"  className={`form-control ${errors.billingCity.length > 0 ? 'is-invalid' : '' }`} placeholder="City" name="billingCity" value={this.state.billingCity} onChange={this.handleChange}></input>
                                  {errors.billingCity.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingCity}</span>}
                                  </div>
                                  <div className='col-md-6 col-sm-6 col-12 text-left'>
                                  <input type="text" class="form-control"  className={`form-control ${errors.billingState.length > 0 ? 'is-invalid' : '' }`} placeholder="State" name="billingState" value={this.state.billingState} onChange={this.handleChange}></input>
                                  {errors.billingState.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingState}</span>}
                                  
                                  </div>
  
                              </div>
  
                              <div className="row  mt-2 ">
                                  <div className="col-md-6 col-sm-6 col-12 text-left">
                                  <input type="text" class="form-control"  className={`form-control ${errors.billingPostalCode.length > 0 ? 'is-invalid' : '' }`} placeholder="Postal Code" name="billingPostalCode" value={this.state.billingPostalCode}  onChange={this.handleChange}></input>
                                  {errors.billingPostalCode.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingPostalCode}</span>}
                                  </div>
                                  <div className='col-md-6 col-sm-6 col-12 text-left'>
                                  <input type="text" class="form-control"  className={`form-control ${errors.billingCountry.length > 0 ? 'is-invalid' : '' }`} placeholder="Country" name="billingCountry"  value={this.state.billingCountry} onChange={this.handleChange}></input >
                                  {errors.billingCountry.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingCountry}</span>}
                                  </div>
  
                              </div>
                              </div>
                              <div className='d-block d-md-none'>
                              <div className="row text-left">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_head">Billing Address*</label>
                                </div>
                                
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class="payment_info_sub">Country*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                  <input  type="text" class="form-control" name="billingCountry" className={`form-control ${errors.billingCountry.length > 0 ? 'is-invalid' : '' }`} value={this.state.billingCountry} onChange={this.handleChange}>
                                  </input>
                                  {errors.billingCountry.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingCountry}</span>}
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">First Name*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control" name="firstName" className={`form-control ${errors.firstName.length > 0 ? 'is-invalid' : '' }`} onChange={this.handleChange} value={this.state.firstName} ></input>
                                {errors.firstName.length > 0 && 
                                  <span className='invalid-feedback'>{errors.firstName}</span>}
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">Last Name*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control" name="lastName" className={`form-control ${errors.lastName.length > 0 ? 'is-invalid' : '' }`} value={this.state.lastName} onChange={this.handleChange} ></input>
                                {errors.lastName.length > 0 && 
                                  <span className='invalid-feedback'>{errors.lastName}</span>}
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">Street Address1*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control" name="billingAddress1" className={`form-control ${errors.billingAddress1.length > 0 ? 'is-invalid' : '' }`} value={this.state.billingAddress1} onChange={this.handleChange}></input>
                                {errors.billingAddress1.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingAddress1}</span>}
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">Street Address2*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control" name="billingAddress2"  value={this.state.billingAddress2} onChange={this.handleChange}></input>
                              
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">ZipCode*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control"  name="billingPostalCode" className={`form-control ${errors.billingPostalCode.length > 0 ? 'is-invalid' : '' }`}  value={this.state.billingPostalCode} onChange={this.handleChange}></input>
                                {errors.billingPostalCode.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingPostalCode}</span>}
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">City*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control" name="billingCity" className={`form-control ${errors.billingCity.length > 0 ? 'is-invalid' : '' }`} value={this.state.billingCity} onChange={this.handleChange}></input>
                                {errors.billingCity.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingCity}</span>}
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">State*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control" name="billingState" className={`form-control ${errors.billingState.length > 0 ? 'is-invalid' : '' }`} value={this.state.billingState} onChange={this.handleChange}></input>
                                {errors.billingState.length > 0 && 
                                  <span className='invalid-feedback'>{errors.billingState}</span>}
                                </div>
                              </div>
                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">Phone*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control"  name="customerPhone" className={`form-control ${errors.customerPhone.length > 0 ? 'is-invalid' : '' }`} value={this.state.customerPhone} onChange={this.handleChange}></input>
                                {errors.customerPhone.length > 0 && 
                                  <span className='invalid-feedback'>{errors.customerPhone}</span>}
                                </div>
                              </div>

                              <div className="row text-left mt-2">
                                <div className="col-md-12 col-12">
                                  <label class=" payment_info_sub">E-mail Address*</label>
                                </div>
                                <div className="col-md-12 col-12">
                                <input type="text" class="form-control" name="customerEmail" className={`form-control ${errors.customerEmail.length > 0 ? 'is-invalid' : '' }`} value={this.state.customerEmail} onChange={this.handleChange}></input>
                                {errors.customerEmail.length > 0 && 
                                  <span className='invalid-feedback'>{errors.customerEmail}</span>}
                                </div>
                              </div>
                             </div>
                              <div className="row mt-1 mt-3" >
                                  <div className="col-md-6 col-sm-6 col-4 mt-1 text-left p-0">
                                  <lable className="text-left payment_head p-0">Payment Method</lable>
                                  </div>
                                  
                                  </div>
                              <div className="row mt-1 iframeload iframe_height" style={this.state.iframeloading ? {} : {display: 'none'}} >
                                  
                                 <div className="col-md-12  d-flex justify-content-center" >
                                 <img  className="loading_logo_inner" src={process.env.PUBLIC_URL + '/images/loader.gif'}   ></img>
                                 </div>
                              </div>

  
                              <div className="row  mt-1 mb-3  iframe_height" >
                              <div style={this.state.loading ? {} : {display: 'none'}}><Loading   handle_loading={this.handle_loading} /></div>
  
                              <iframe onLoad={this.finishLoading}  ref="iframeid" className="iframe_height"  style={this.state.showmessage ? {display: 'none'} : {display: 'block'}} src={this.state.paymenturl}></iframe>
                              <div style={this.state.showmessage ? {display: 'block'} : {display: 'none'}}><IframeMessage   handle_reload_btn={this.handle_reload_btn} /></div> 
                              
                              </div>
                               
                              <div className="row mt-1  d-block d-md-none">
                        <div className="col-md-2 col-sm-2 col-lg-1 col-12 mb-1 text-left">
                        <button type="button" class="btn back_btn size_12 font_fam" onClick={this.backclick}>Back </button>
  
                        </div>
                        <div className="col-md-4 col-lg-8 col-sm-2 col-1">
  
                        </div>
                  
                       <div className="col-md-6 col-lg-3 col-sm-8 col-12 mb-3">
                                  <button type="button" class="btn orange_btn "  onClick={this.handleSubmit}>CONFIRM  & PAY </button>
                      </div>
     
            </div>
  
                          </div>
                          
             </div>
             

          </div>
                 <div className="mt-2 d-none d-md-block">
                   <div className="row ">
                   <div className="col-md-2 col-sm-2 col-lg-1 col-12 mb-1 text-left">
                        <button type="button" class="btn back_btn size_12 font_fam" onClick={this.backclick}>Back </button>
  
                        </div>
                        <div className="col-md-4 col-lg-8 col-sm-2 col-1">
  
                        </div>
                  
                       <div className="col-md-6 col-lg-3 col-sm-8 col-12 mb-3">
                                  <button type="button" class="btn orange_btn "  onClick={this.handleSubmit}>CONFIRM  & PAY </button>
                      </div>
                   </div>
                     
     
                  </div>
          </div>
           {/* <div ><IframeMessage   handle_message={this.handle_message} /></div>  */}
     
        </div>
      );
    }
  
}

export default withRouter(Payment_Page);
